import {
  FETCH_PAYMENT_ORDER_DETAIL_PENDING,
  FETCH_PAYMENT_ORDER_DETAIL_REJECTED,
  FETCH_PAYMENT_ORDER_DETAIL_FULFILLED,
  CLEAR_FETCH_PAYMENT_ORDER_DETAIL,
} from 'constants/paymentOrderDetail';

const initialState = {
  pending: true,
  orderDetails: {},
  error: {},
  success: false,
};

export const paymentOrderDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_ORDER_DETAIL_FULFILLED:
      return {
        ...state,
        orderDetails: action.response,
        pending: false,
        success: true,
      };

    case FETCH_PAYMENT_ORDER_DETAIL_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PAYMENT_ORDER_DETAIL_PENDING:
      return {
        ...state,
        error: {},
      };

    case CLEAR_FETCH_PAYMENT_ORDER_DETAIL:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paymentOrderDetail.js